import { Methods } from '@api/follow/check'
import { Request } from '../../request'
export default async (query:Methods["get"]["query"]) => Request( client => client.follow.check.$get({query}) )
